import React from 'react';
import { Box, Card, CardContent, Typography, LinearProgress, Stack } from '@mui/material';

export function StatCard({ title, value, subtitle, color = 'primary.main', icon }) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        transition: 'transform 0.15s, box-shadow 0.15s',
        '&:hover': { transform: 'translateY(-2px)', boxShadow: 2 },
      }}
    >
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {title}
          </Typography>
          {icon && <Box sx={{ color, fontSize: 20 }}>{icon}</Box>}
        </Stack>
        <Typography variant="h4" fontWeight={700} sx={{ mt: 1, color }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export function ProgressBar({ value, label, color = 'primary' }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
        <Typography variant="body2" fontWeight={500}>{label}</Typography>
        <Typography variant="body2" color="text.secondary">{value}%</Typography>
      </Stack>
      <LinearProgress variant="determinate" value={Math.min(100, value)} color={color} sx={{ height: 8, borderRadius: 4 }} />
    </Box>
  );
}

export function SectionHeader({ title, subtitle, action }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
      <Box>
        <Typography variant="h5" fontWeight={700}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        )}
      </Box>
      {action}
    </Stack>
  );
}

export const cardSx = {
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
};
